import { Component, HostBinding, Output, EventEmitter, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'suka-card-footer',
  template: `
    <suka-button-group>
      <button
        *ngIf="showSecondaryButton"
        sukaButton="plain"
        (click)="onButtonClick('secondary')"
      >
        {{secondaryLabel}}
      </button>
      <button
        sukaButton="primary"
        (click)="onButtonClick('primary')"
      >
        {{primaryLabel}}
      </button>
    </suka-button-group>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class CardFooter implements OnInit {
  showSecondaryButton = false;

  @HostBinding('class.card-footer') baseClass = true;

  @Input() primaryLabel: string;
  @Input() secondaryLabel: string;
  @Output() primaryAction = new EventEmitter();
  @Output() secondaryAction = new EventEmitter();

  ngOnInit() {
    this.showSecondaryButton = this.secondaryAction.observers.length > 0;
  }

  onButtonClick(buttonType: string) {
    if (buttonType === 'primary') {
      this.primaryAction.emit();
    }

    if (buttonType === 'secondary') {
      this.secondaryAction.emit();
    }
  }
}
